import { useEffect, useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Blog from "./pages/Blog";
import Post from "./pages/Post";

// Hash-based routing (#/projects, #/blog) so pages work on any static host
// without server rewrite rules. Also accepts the old one-page anchors
// (#projects, #experience) and trailing slashes.
function getPath() {
  const raw = window.location.hash.replace(/^#\/?/, "").replace(/\/+$/, "");
  try {
    return `/${decodeURIComponent(raw)}`;
  } catch {
    return `/${raw}`;
  }
}

// Sections on the home page that can be linked to directly, e.g. #/experience
const homeSections = ["/about", "/experience"];

function useHashPath() {
  const [path, setPath] = useState(getPath);

  useEffect(() => {
    const onChange = () => {
      setPath(getPath());
      window.scrollTo(0, 0);
    };
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);

  useEffect(() => {
    if (homeSections.includes(path)) {
      document.getElementById(path.slice(1))?.scrollIntoView({ behavior: "smooth" });
    }
  }, [path]);

  return path;
}

function renderPage(path) {
  if (path === "/projects") return <Projects />;
  if (path === "/blog") return <Blog />;
  if (path.startsWith("/blog/")) return <Post slug={path.slice("/blog/".length)} />;
  return <Home />;
}

function App() {
  const path = useHashPath();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar path={path} />
      <main className="flex-1">{renderPage(path)}</main>
      <Footer />
    </div>
  );
}

export default App;
